import React, { useEffect, useState } from 'react';
import { Fade } from 'react-reveal';

// import components
import Logo from '../assets/img/favicon.png';
import Nav from '../components/Nav';
import NavMobile from '../components/NavMobile';
import Socials from './Socials';
import { Helmet } from 'react-helmet';

const Header = () => {
  const [bg, setBg] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      return window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  });

  return (
    <header
      className={`${bg ? 'bg-tertiary h-16' : 'h-24 z-50'
        } flex items-center fixed top-0 w-full text-white z-10 transition-all duration-300`}
    >
      <Helmet>
        <title>Developer Nahid</title>
        <meta name="description" content="Explore my portfolio showcasing expertise in web development using the MERN stack and other cutting-edge technologies." />
        <meta name="keywords" content="developer, nahid, moazzemhossainnahid, moazzemnahid,mhnahid,reactdeveloper,react,nextjs,webdevelopernahid,MERN,merndevelopernahid,merndeveloper, web development, MERN stack, Web Developer Nahid" />
      </Helmet>

      <div className='container mx-auto h-full flex items-center justify-between'>
        {/* logo */}
        <a className='flex items-center gap-1' href='#home'>
          <Fade bottom>
            <img className="w-16" src={Logo} alt='' /> <span className='text-3xl font-bold'>Developer Nahid</span>
          </Fade>
        </a>
        {/* nav */}
        <div className='hidden lg:block'>
          <Fade top>
            <Nav />
          </Fade>
        </div>
        {/* Socials */}
        <div className='hidden lg:block'>
          <Socials />
        </div>
        {/* nav mobile*/}
        <div className='lg:hidden'>
          <NavMobile />
        </div>
      </div>
    </header>
  );
};

export default Header;
